import { useAppSelector } from '@common/hooks/store';
import { useGetSuperExactScoreBonusQuery } from '@features/super-exact-score/api/superExactScoreApi';
import Typography from '@mui/material/Typography';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const SuperExactScoreBonuses = () => {
  const { data: superExactScoreBonusData } = useGetSuperExactScoreBonusQuery();
  const currency = useAppSelector((state) => state.auth.user?.currency);

  if(!currency || !superExactScoreBonusData) {
    return null
  }

  const bonus = superExactScoreBonusData.find((item) => item.type === 2 && item.currencyId === currency.id);

  if(bonus) {
    return (
      <Typography fontSize="0.8em" fontWeight={500} className="super-exact-score-bonuses">
        <FormattedMessage id="SUPER_EXACT_SCORE_MAIN_PRIZE"/>
        {": "} {bonus.sum} {currency.code}
      </Typography>
    )
  }
  else {
    return null;
  }
}

export default SuperExactScoreBonuses;